import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

const usePermisos = () => {
    const context = useContext(AuthContext);
    if (!context) throw new Error('usePermisos debe usarse dentro de AuthProvider');

    return {
        can: context.can,
        loaded: !context.loading,
        isSuperAdmin: context.user?.role_slug === 'superadmin',
        isAdmin: context.user?.role_slug === 'admin',
    };
};

export default usePermisos;
